// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getDatabase } from "firebase/database";



const firebaseConfig = {
  apiKey: "AIzaSyCQ7MRh6yup5pA7MLmFl0r7N0bVejGVGx0",
  authDomain: "bizcontrol-478cd.firebaseapp.com",
  databaseURL: "https://bizcontrol-478cd-default-rtdb.firebaseio.com",
  projectId: "bizcontrol-478cd",
  storageBucket: "bizcontrol-478cd.firebasestorage.app",
  messagingSenderId: "367320678787",
  appId: "1:367320678787:web:662aca44ac92efbd7436b6",
  measurementId: "G-581B8BFGCW"
};


// 🔥 تشغيل Firebase في مشروعك
export  const app = initializeApp(firebaseConfig);

// 🧱 تفعيل خدمات Firebase
export const auth = getAuth(app);       // المصادقة (تسجيل الدخول)
export const db = getDatabase(app);    // قاعدة البيانات Firestore

